(() => {
  const ROOT = "[data-moodz-pdp-upsells]";
  const TRACK = "[data-upsell-track]";
  const CARD = "[data-upsell-card]";
  const ADD = "[data-upsell-add]";
  const SELECT = "[data-upsell-variant-select]";
  const MSG = "[data-upsell-msg]";
  const PREV = "[data-upsell-prev]";
  const NEXT = "[data-upsell-next]";

  // ─────────────────────────────────────────────────────────────
  // Helpers UI
  // ─────────────────────────────────────────────────────────────
  function setLoading(btn, isLoading) {
    if (!btn) return;
    btn.disabled = !!isLoading;
    btn.classList.toggle("is-loading", !!isLoading);
  }

  function showMsg(card, text, type = "info") {
    const btn = card?.querySelector(ADD);
    const feedback = btn?.querySelector('.moodz-pdp-upsell__btn-feedback');
    if (!btn) return;
    if (feedback) {
      feedback.textContent = text;
    }
    btn.classList.remove('is-success', 'is-error');
    if (type === 'success') btn.classList.add('is-success');
    if (type === 'error')   btn.classList.add('is-error');
    setTimeout(function () {
      btn.classList.remove('is-success', 'is-error');
      if (feedback) feedback.textContent = '';
    }, 2500);
  }

  function getVariantIdFromCard(card) {
    const select = card.querySelector(SELECT);
    const fallback = card.getAttribute("data-upsell-default-variant-id");
    return String(select?.value || fallback || "").trim();
  }

  // ─────────────────────────────────────────────────────────────
  // Cart
  // ─────────────────────────────────────────────────────────────
  async function addToCartFormEncoded(variantId, quantity = 1) {
    const body = new URLSearchParams();
    body.set("id", String(variantId));
    body.set("quantity", String(quantity));

    const res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body,
    });

    const text = await res.text();
    let data = {};
    try { data = text ? JSON.parse(text) : {}; } catch (e) {}

    if (!res.ok) {
      const message =
        data?.description ||
        data?.message ||
        (typeof data === "string" ? data : null) ||
        "Impossible d'ajouter au panier.";
      throw new Error(message);
    }
    return data;
  }

  async function refreshThemeCart(cartData) {
    if (typeof window.publish === "function") {
      window.publish("cart-update", { source: "moodz-pdp-upsells", cartData: cartData || null });
    }
  }

  function openCartDrawerIfExists() {
    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
      return true;
    }
    const drawer = document.querySelector("cart-drawer");
    if (drawer) {
      drawer.classList.remove("is-empty");
      drawer.classList.add("active", "animate");
      document.body.classList.add("overflow-hidden");
      return true;
    }
    return false;
  }

  // ─────────────────────────────────────────────────────────────
  // SLIDER — logique flèches uniquement, pas de wheel hijack
  // ─────────────────────────────────────────────────────────────
  function getCards(track) {
    return Array.from(track.querySelectorAll(CARD));
  }

  function getCardsPerView(track) {
    const cards = getCards(track);
    if (!cards.length) return 1;
    const trackW = track.getBoundingClientRect().width;
    const cardW = cards[0].getBoundingClientRect().width + 12; // 12 = gap
    return Math.max(1, Math.round(trackW / cardW));
  }

  function getCurrentIndex(track) {
    const cards = getCards(track);
    if (!cards.length) return 0;
    // L'index courant = la carte la plus proche du bord gauche du track
    const scrollLeft = track.scrollLeft;
    let bestIdx = 0, bestDist = Infinity;
    cards.forEach((card, i) => {
      const dist = Math.abs(card.offsetLeft - scrollLeft);
      if (dist < bestDist) { bestDist = dist; bestIdx = i; }
    });
    return bestIdx;
  }

  function goToIndex(track, idx) {
    const cards = getCards(track);
    if (!cards.length) return;
    const clamped = Math.max(0, Math.min(idx, cards.length - 1));
    track.scrollTo({ left: cards[clamped].offsetLeft, behavior: "smooth" });
  }

  function updateArrows(track, prev, next) {
    if (!prev || !next) return;
    const cards = getCards(track);
    const perView = getCardsPerView(track);
    const idx = getCurrentIndex(track);
    prev.disabled = idx === 0;
    next.disabled = idx >= cards.length - perView;
    // Visibilité
    prev.style.opacity = prev.disabled ? "0.3" : "1";
    next.style.opacity = next.disabled ? "0.3" : "1";
  }

  // ─────────────────────────────────────────────────────────────
  // BIND
  // ─────────────────────────────────────────────────────────────
  function bind(root) {
    if (!root || root.dataset.moodzBound === "true") return;
    root.dataset.moodzBound = "true";

    const track = root.querySelector(TRACK);
    const prev = root.querySelector(PREV);
    const next = root.querySelector(NEXT);

    // ---------- Mise à jour prix bouton au changement de variante ----------
    root.addEventListener("change", (e) => {
      const select = e.target.closest(SELECT);
      if (!select) return;
      const card = select.closest(CARD);
      if (!card) return;
      const opt = select.options[select.selectedIndex];
      if (!opt) return;

      const priceEl   = card.querySelector(".moodz-pdp-upsell__btn-price");
      const currency  = window.Shopify?.currency?.active || "EUR";
      const locale    = document.documentElement.lang || "fr-FR";

      const price     = parseInt(opt.dataset.price   || "0", 10);
      const compare   = parseInt(opt.dataset.compare || "0", 10);

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(locale, { style: "currency", currency: currency });
      }

      if (priceEl) {
        priceEl.innerHTML = (compare > price)
          ? '<s class="moodz-pdp-upsell__btn-price-compare">' + formatMoney(compare) + '</s> ' + formatMoney(price)
          : formatMoney(price);
      }
    });

    // ---------- Add to cart ----------
    root.addEventListener("click", async (e) => {
      const btn = e.target.closest(ADD);
      if (!btn) return;

      const card = btn.closest(CARD);
      if (!card) return;
      e.preventDefault();

      const variantId = getVariantIdFromCard(card);
      if (!variantId) {
        showMsg(card, "Variante invalide (ID manquant).", "error");
        return;
      }


      try {
        setLoading(btn, true);
        showMsg(card, "Ajout en cours…", "info");

        const cartData = await addToCartFormEncoded(variantId, 1);
        showMsg(card, "Ajouté ✅", "success");
        await refreshThemeCart(cartData);

        openCartDrawerIfExists();
      } catch (err) {
        showMsg(card, err?.message || "Erreur lors de l'ajout.", "error");
      } finally {
        setLoading(btn, false);
      }
    });
 
    if (!track) return;

    // ---------- Flèches uniquement — AUCUN wheel hijack ----------
    if (prev) {
      prev.addEventListener("click", () => {
        const perView = getCardsPerView(track);
        goToIndex(track, getCurrentIndex(track) - perView);
        setTimeout(() => updateArrows(track, prev, next), 350);
      });
    }

    if (next) {
      next.addEventListener("click", () => {
        const perView = getCardsPerView(track);
        goToIndex(track, getCurrentIndex(track) + perView);
        setTimeout(() => updateArrows(track, prev, next), 350);
      });
    }

    // Mise à jour des flèches au scroll (natif, sans interférence)
    track.addEventListener("scroll", () => {
      updateArrows(track, prev, next);
    }, { passive: true });

    // Init état des flèches
    updateArrows(track, prev, next);

    // Recalcul au resize
    let resizeTimer = null;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => updateArrows(track, prev, next), 150);
    });

    // ⚠️ AUCUN listener wheel — le scroll vertical de la page reste libre
  }

  // ─────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll(ROOT).forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();